/**
 * Configuração central do site: URL pública e trava de indexação.
 *
 * Nenhum outro ponto do código deve conter a URL do site escrita à mão —
 * canonical, Open Graph, sitemap e robots.txt saem todos daqui, para que a
 * troca para o domínio definitivo seja só mudar VITE_SITE_URL no .env.
 */

/** URL pública do site, sem barra no final. */
export function siteUrl(): string {
  const url = import.meta.env["VITE_SITE_URL"] as string | undefined;
  if (!url) {
    throw new Error("VITE_SITE_URL não definida no .env");
  }
  return url.replace(/\/+$/, "");
}

/** Monta uma URL absoluta a partir de siteUrl(). Aceita path com ou sem "/". */
export function absoluteUrl(path: string): string {
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return `${siteUrl()}${normalized}`;
}

/**
 * Trava de indexação. Enquanto VITE_SITE_INDEXABLE !== "true", o site
 * emite noindex/nofollow em todas as páginas e o robots.txt bloqueia tudo.
 */
export function isIndexable(): boolean {
  return import.meta.env["VITE_SITE_INDEXABLE"] === "true";
}
